import { render, staticRenderFns } from "./FlowyHistoryDatatable.vue?vue&type=template&id=3ffff3b0&class=custom-bg"
import script from "./FlowyHistoryDatatable.vue?vue&type=script&lang=js"
export * from "./FlowyHistoryDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports